(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CheckerStatisticsReport', CheckerStatisticsReport);

    CheckerStatisticsReport.$inject = ['$resource'];

    function CheckerStatisticsReport ($resource) {
        var resourceUrl =  'api/report/phone-call-checks-checker-statistics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
